/**
 * End the server stats session (and optionally mark played) for the current
 * queue position before clearing playback.
 */
import { qualifiesAsPlay } from "@memes/shared";
import { statsApi, tracksApi } from "./api";
import { usePlayer } from "../state/player";

export async function finalizeListenForTrack(
  trackId: number,
  listened: number,
  durationSec: number | null | undefined,
): Promise<void> {
  if (listened <= 0) return;
  await statsApi.endSession(listened);
  if (qualifiesAsPlay(listened, durationSec)) {
    await tracksApi.markPlayed(trackId);
  }
}

/** Finalize listen stats for whichever track is at the current queue index. */
export async function finalizeActiveListen(): Promise<void> {
  const { queue, index, audio, currentTime } = usePlayer.getState();
  const track = queue[index];
  if (!track) return;
  await finalizeListenForTrack(
    track.id,
    audio?.currentTime ?? currentTime,
    track.durationSec,
  );
}
